import React from "react"
import { Box, Container, Text, AspectRatio } from "@theme-ui/components"

const Embed = ({ title, code, fullWidth }) => {
  const Wrapper = fullWidth ? Box : Container
  const isYouTube = /<iframe[^>]*src=["'][^"']*(?:youtube\.com\/embed\/|youtu\.be\/|youtube-nocookie\.com\/embed\/)/i.test(code)

  // Remove width and height attributes from YouTube iframes to allow AspectRatio to work
  const processedCode = isYouTube
    ? code.replace(/\s+(width|height)=["'][^"']*["']/gi, '')
    : code

  return (
    <Wrapper mb={5}>
      {title && <Text mb={3}>{title}</Text>}
      {isYouTube ? (
        <AspectRatio ratio={16/9}>
          <Box
            sx={{
              iframe: {
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%"
              }
            }}
            dangerouslySetInnerHTML={{ __html: processedCode }}
          />
        </AspectRatio>
      ) : (
        <Box
          sx={{ iframe: { width: "100%" } }}
          dangerouslySetInnerHTML={{ __html: code }}
        />
      )}
    </Wrapper>
  )
}

export default Embed
